import './index.css';
import App from './App';
import React from 'react';
import {Provider} from 'react-redux';
import ReactDOM from 'react-dom/client';
import {store} from './Redux/CreateStore';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from "@material-tailwind/react";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	
		<Provider store={store}>
			<ThemeProvider>
				<App />
			</ThemeProvider>
		</Provider>
	
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
